"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var ModalContent = function ModalContent(props) {
  var showArrow = props.showArrow,
      arrowPosition = props.arrowPosition;
  var modalButtons = props.modalButtons && Object.keys(props.modalButtons).length > 0 ? props.modalButtons : undefined; // const modalContent = props.modalContent;

  if (modalButtons) {
    return React.createElement(React.Fragment, null, showArrow && React.createElement("div", {
      className: "gib-r-drpd-m-_ModalArrow",
      style: {
        marginLeft: arrowPosition.left ? arrowPosition.left : 'auto',
        marginRight: arrowPosition.right ? arrowPosition.right : '0px'
      }
    }), React.createElement("div", {
      className: "gib-r-drpd-m-_ModalContent"
    }, Object.keys(modalButtons).map(function (key, i) {
      return React.createElement("button", {
        className: "gib-r-drpd-m-_ModalContent_btn_001",
        key: i,
        onClick: modalButtons[key],
        style: i === 0 ? {
          borderTop: '0px solid white'
        } : {}
      }, key);
    })));
  } else if (props.modalContent) {
    return React.createElement(React.Fragment, null, props.modalContent());
  } else {
    return React.createElement("div", null, "Content here!");
  }
};

var _default = ModalContent;
exports.default = _default;